import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, ShoppingBag } from 'lucide-react';
import { useCart } from './contexts/CartContext';
import './styles/CartPage.css';

const CartPage: React.FC = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity, getCartTotal } = useCart();

  return (
    <div className="cart-page">
      <div className="cart-page-container">
        <div className="cart-page-header">
          <div>
            <h1 className="cart-page-title">Bag</h1>
            <p className="cart-page-subtitle">
              {cartItems.length === 0
                ? 'Your bag is empty'
                : `${cartItems.reduce((total, item) => total + item.quantity, 0)} items`
              }
            </p>
          </div>
          <button
            onClick={() => navigate(-1)}
            className="cart-close-btn"
            aria-label="Close cart"
          >
            <X size={24} />
          </button>
        </div>

        {cartItems.length === 0 ? (
          <div className="cart-empty-state">
            <ShoppingBag size={80} className="empty-cart-icon" />
            <h2>Your bag is empty</h2>
            <p>Start adding items to your bag</p>
          </div>
        ) : (
          <div className="cart-content-grid">
            <div className="cart-items-section">
              <div className="cart-items-card">
                {cartItems.map((item) => (
                  <div key={item.id} className="cart-page-item">
                    <img src={item.image} alt={item.name} className="cart-page-item-image" />

                    <div className="cart-page-item-details">
                      <h3 className="cart-page-item-name">{item.name}</h3>
                      <p className="cart-page-item-price">{item.price}</p>

                      <div className="cart-page-item-actions">
                        <div className="cart-page-quantity-control">
                          <button
                            onClick={() => updateQuantity(item.id, item.quantity - 1)}
                            className="quantity-btn"
                          >
                            -
                          </button>
                          <span className="quantity-display">{item.quantity}</span>
                          <button
                            onClick={() => updateQuantity(item.id, item.quantity + 1)}
                            className="quantity-btn"
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="cart-page-item-right">
                      <button
                        onClick={() => removeFromCart(item.id)}
                        className="remove-btn"
                      >
                        <X size={20} />
                      </button>
                      <div className="cart-page-item-total">
                        ${(parseFloat(item.price.replace('$', '')) * item.quantity).toFixed(2)}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="cart-summary-section">
              <div className="cart-summary">
                <h2 className="summary-title">Summary</h2>
                <div className="summary-row">
                  <span>Subtotal</span>
                  <span>${getCartTotal().toFixed(2)}</span>
                </div>
                <div className="summary-row">
                  <span>Shipping</span>
                  <span>FREE</span>
                </div>
                <div className="summary-divider"></div>
                <div className="summary-row summary-total">
                  <span>Total</span>
                  <span>${getCartTotal().toFixed(2)}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {cartItems.length > 0 && (
        <div className="cart-footer">
          <button className="checkout-btn" onClick={() => navigate('/checkout')}>
            Checkout
          </button>
          <button onClick={() => navigate('/products')} className="continue-shopping-btn">
            Continue Shopping
          </button>
        </div>
      )}
    </div>
  );
};

export default CartPage;
